import Label from 'components/ui/label'

import * as Primitive from '../../primitive'
import type { RadioOption } from '../../index'

interface SimpleRadioProps {
  option: RadioOption
  isChecked?: boolean
}

export function SimpleRadio({ option, isChecked }: SimpleRadioProps) {
  const uniqueValue = option.value?.toString() || option.id.toString()
  return (
    <div className="tw-flex tw-items-center tw-space-x-2">
      <Primitive.Item
        value={uniqueValue}
        id={uniqueValue}
        {...(isChecked !== undefined && {
          checked: isChecked,
        })}
      />
      {option.customLabel || (
        <Label
          htmlFor={uniqueValue}
          className="tw-cursor-pointer tw-font-medium tw-text-zinc-950"
        >
          {option.title}
        </Label>
      )}
    </div>
  )
}
